const React = require('react');
const MenuItem = require('@material-ui/core/MenuItem').default;
const OutlinedInput = require('@material-ui/core/OutlinedInput').default;
const uniqIdProvider = require('mn-utils/uniqIdProvider');
const find = require('mn-utils/find');
const noopHandle = require('mn-utils/noopHandle');
const get = require('mn-utils/get');
const map = require('mn-utils/map');
const isDefined = require('mn-utils/isDefined');
const isArray = require('mn-utils/isArray');
const isFunction = require('mn-utils/isFunction');
const upperFirst = require('mn-utils/upperFirst');
const without = require('mn-utils/without');
const withState = require('../../../utils/withState');

const getId = uniqIdProvider('select_');
const WITHOUT_PROPS = [
  'placeholder',
  'propValue',
  'propName',
  'items',
  'value',
  'inputComponent',
  'onChange',
  'multiple',
  'displayEmpty',
];


module.exports = (render) => {
  return withState((setState, self, onMount) => {
    const elId = getId();
    let inputLabelRef;

    onMount(() => {
      setState({
        labelWidth: inputLabelRef && inputLabelRef.offsetWidth || 0,
      });
    });

    function onRef(ref) {
      inputLabelRef = ref;
    }
    function handleChange(e) {
      const {
        onChange,
      } = self.props;
      onChange && onChange(e.target.value);
    }

    return (state, props) => {
      const displayEmpty = props.displayEmpty || false;
      const placeholder = props.placeholder || '';
      const propValue = props.propValue;
      const propName = props.propName;
      const multiple = props.multiple || false;
      const InputComponent = props.inputComponent || OutlinedInput;
      const items = props.items || [];

      let value = props.value || '';
      multiple
        ? (isArray(value) || (value = []))
        : (
          isDefined(propValue)
            ? (
              find(items, [propValue, value])
                || (get(items, '0.' + propValue)) === undefined
            )
            : find(items, [[], value])
        );

      const _propValue = isDefined(propValue)
        ? (isFunction(propValue) ? propValue : ((item) => get(item, propValue)))
        : noopHandle;
      const _propName = isDefined(propName)
        ? (
        isFunction(propName)
          ? propName
          : ((item) => upperFirst('' + (get(item, propName) || _propValue(item))))
        )
        : noopHandle;

      return render({
        control: without(props, WITHOUT_PROPS),
        label: {
          ref: onRef,
          htmlFor: elId,
          id: elId + '-label',
          children: placeholder,
        },
        select: {
          className: value ? 'selected' : 'empty',
          displayEmpty,
          multiple,
          value,
          onChange: handleChange,
          input: (
            <InputComponent
              labelWidth={state.labelWidth || 0}
              name={placeholder}
              id={elId}
            />
          ),
          children: map(items, (item) => {
            const value = _propValue(item);
            const disabled = !!(item && item.disabled);

            if (item.separator) {
              return (
                <MenuItem
                  key={value}
                  value={value}
                  disabled
                >
                  <div className="w">
                    <div className="h1 bg6 mh-10"/>
                  </div>
                </MenuItem>
              );
            }
            return (
              <MenuItem
                key={value}
                value={value}
                disabled={disabled}
              >{_propName(item)}</MenuItem>
            );
          }),
        },
      });
    };
  }, {});
};
